export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11159.c0fe2759.jpg";